<!-- 侧边栏 -->
<template>
  <div class="content">
    <div
      style="height: 60px"
      :style="{
        width: isCollapse ? closeWidth : openWidth,
      }"
    >
      <div
        style="
          position: fixed;
          width: 200px;
          background-color: #282637;
          z-index: 10;
        "
        :style="{
          width: isCollapse ? closeWidth : openWidth,
        }"
      >
        <div class="logoBox">
          <img
            :style="{
              width: logoWidth,
            }"
            class="logoImg"
            src="../../assets/logo.png"
            alt=""
          />
          <span
            v-if="!isCollapse"
            class="title"
            style="display: block; line-height: 120%; margin-left: 15px"
          >
            <!-- {{ groupName }} -->
            备考通平台</span
          >
        </div>
      </div>
    </div>
    <el-menu
      background-color="#181626"
      text-color="#fff"
      :default-active="activePath"
      :router="true"
      active-text-color="#7861FF"
      :collapse="isCollapse"
      @open="handleOpen"
      @close="handleClose"
    >
      <div v-for="(item, index) in routesList" :key="index">
        <div class="noChild" v-if="!item.children">
          <el-menu-item :index="item.index">
            <i
              class="picA1"
              :style="{
                background: 'url(' + item.pic_a1 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              }"
            ></i>
            <i
              class="picA2"
              :style="{
                background: 'url(' + item.pic_a2 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              }"
            ></i>
            <i
              class="picA3"
              :style="{
                background: 'url(' + item.pic_a3 + ')' + ' ' + 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '14px 14px',
                display: 'inline-block',
                width: '24px',
                height: '24px',
                verticalAlign: 'middle',
              }"
            ></i>

            <!-- <i :class="item.icon"></i> -->
            <span v-if="!isCollapse"
              >{{ item.name }}
              <i
                class="el-icon-warning"
                style="color: red"
                v-if="item.index == '/institutionsOption' && checkInfoStatus"
              ></i>
            </span>
          </el-menu-item>
        </div>
        <div class="haveChild" v-else>
          <el-submenu :index="item.index">
            <template slot="title">
              <!-- <i :class="item.icon"></i> -->

              <i
                class="picA1"
                :style="{
                  background: 'url(' + item.pic_a1 + ')' + ' ' + 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: '14px 14px',
                  display: 'inline-block',
                  width: '24px',
                  height: '24px',
                  verticalAlign: 'middle',
                }"
              ></i>
              <i
                class="picA2"
                :style="{
                  background: 'url(' + item.pic_a2 + ')' + ' ' + 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: '14px 14px',
                  display: 'inline-block',
                  width: '24px',
                  height: '24px',
                  verticalAlign: 'middle',
                }"
              ></i>
              <i
                class="picA3"
                :style="{
                  background: 'url(' + item.pic_a3 + ')' + ' ' + 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: '14px 14px',
                  display: 'inline-block',
                  width: '24px',
                  height: '24px',
                  verticalAlign: 'middle',
                }"
              ></i>

              <span v-if="!isCollapse">{{ item.name }}</span>
            </template>

            <div v-for="(_item, _index) in item.children" :key="_index">
              <div v-if="_item.children && _item.children.length > 0">
                <el-submenu :index="_item.index">
                  <span slot="title">{{ _item.name }}</span>
                  <el-menu-item
                    v-for="(_itemB, _indexB) in _item.children"
                    :key="_itemB.index"
                    :index="_itemB.index"
                    >{{ _itemB.name }}</el-menu-item
                  >
                </el-submenu>
              </div>
              <div v-else>
                <el-menu-item  v-if="_item.index=='/operationManual'" :index="_item.index" @click="operationManual">{{
                  _item.name
                }}</el-menu-item>

                <el-menu-item v-else :index="_item.index">{{
                  _item.name
                }}</el-menu-item>
              </div>
            </div> 
          </el-submenu>
        </div>
      </div>
    </el-menu>

    <!-- <div class="shrink" @click="shrinkClick()">
      <i v-if="!isCollapse" class="el-icon-arrow-left"></i>
      <i v-else class="el-icon-arrow-right"></i>
    </div> -->
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { truncate } from "fs";
import goodsApi from "@/api/goods.js";
import Bus from "@/utils/bus.js";
import { deepClone } from "@/utils";
export default {
  name: "Sliber",
  data() {
    return {
      routesList: [],
      asideList: [],
      checkInfo: {},
      role: "", // 高级管理员 admin 普通管理员 generaladministrato 单位老师  nstitutionalteacher 招生专员  salespersonr 外呼专员  outboundcall
      isCollapse: true,
      // openMenuArr: ["1", "2", "3", "4", "5", "6"],
      groupName: "",
      closeWidth: "64px !important",
      openWidth: "200px !important",
      pic_a1: require("../../assets/new/submenu_a1_1.png"),
      logoWidth: "36px !important",
      shareLinkData: "https://docs.qq.com/doc/DT01TRnJpdVZLT2Ns",
      activePath:'',
      Ifopen: "",
      is_show_custom_order: ""
    };
  },
  watch: {
    '$route.path'(toPath, fromPath) {
      console.log("$route----", `Navigating from ${fromPath} to ${toPath}`);
      // 在这里执行你的逻辑
      this.getActivePath()
    }
  },
  computed: {
    classObje() {
      return (_item, route) => {
        if (typeof _item == "string" && _item.indexOf(route) != -1) {
          return true;
        } else {
          return false;
        }
      };
    },
    checkInfoStatus() {
      let _obj = this.$store.state.user.userInfo.check;
      if (_obj && Object.keys(_obj) && _obj.status == 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getMe();
    this.getDic()
    // 给侧边栏显示列表赋值
    console.log("asideList", this.$store.state.asideList)
    this.getScreenWidth(); 
    Bus.$on("getListInfo", (data) => {
      this.isCollapse = data; 
    });
  },
  methods: { 
    getDic() {
      commonApi.getInfoToName({ name: "BKTOperManualTypeList" }).then((res) => { 
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "Ifopen") { 
              this.Ifopen = item.value
              localStorage.setItem("Ifopen", item.value) 
            }
          });
        }
      });
    },  

    getActivePath(){
      console.log("getActivePath", this.$route.path)
      this.routesList.forEach((itemA) => {
        if(itemA.index==this.$route.path){
          this.activePath = this.$route.path
        }
        if(itemA.children&&itemA.children.length>0){
          itemA.children.forEach((itemB) => {
            if(itemB.index==this.$route.path){
              this.activePath = this.$route.path
            } 
          })
        }
        if(itemA.children1&&itemA.children1.length>0){
          itemA.children1.forEach((itemB) => {
            if(itemB.index==this.$route.path){
              this.activePath = this.$route.path
            } 
          })
        }  
      })

      // this.routeSkip(this.activePath)
      console.log("this.activePath",this.activePath,this.routesList)
    },
    operationManual() {
      // 操作手册
      if(this.Ifopen=='1'){  
        this.$router.push("/helpManualList");
      }else{
        window.open(this.shareLinkData, "_blank")
      }
    },
    async getMe() {
      const res = await commonApi.tobMe()
      if (res.code === 200) {
        this.role = res.data.role 
        localStorage.setItem("myUserInfo", JSON.stringify(res.data))
        localStorage.setItem("group_id", res.data.group.id)
        console.log("getMe", res.data)

        this.is_show_custom_order = res.data.is_show_custom_order

        if(this.role=='admin' || this.role=='generaladministrato'){ 
          localStorage.setItem("excelShow", 1)
        }else{
          localStorage.setItem("excelShow", 0)
        }
        if(this.role=='nstitutionalteacher' || this.role=='salespersonr' || this.role=='outboundcall'){  
          this.$store.state.openTab = [] 
          this.$store.commit("delete_tabs", "/home")
          console.log("this.$store",this.$store) 
        } 
        
        this.getTobHideMenu();
      }
    },
    getScreenWidth() {
      var screenWidth = document.body.clientWidth;
      if (screenWidth < 979) {
        this.isCollapse = true;
        this.closeWidth = "0 !important";
        this.logoWidth = "0 !important";
      } else {
        this.isCollapse = false;
        this.closeWidth = "64px !important";
        this.logoWidth = "36px !important";
      }
    },
    getTobHideMenu() {
      this.asideList = deepClone(this.$store.state.asideList); 
      goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          var routesList = []; 
          console.log("asideList---", this.is_show_custom_order,this.asideList,this.$store.state.user.userInfo.role);
          this.asideList.forEach((item, index) => {
            if (item.roles.includes(this.role)) {
              routesList.push(item);
            }
          });
          routesList.forEach((itemA, indexA) => {
            if(itemA.children && itemA.children.length > 0){
              const routesArr = []
              itemA.children.forEach((itemB, indexB) => {
                if (itemB.roles.includes(this.role)) {
                  routesArr.push(itemB)
                }
              })
              itemA.children = routesArr
            }
          }) 
          
          routesList.forEach((itemA, indexA) => {
            if (itemA.index == "/goodsManage") {
              // if(this.role=='salespersonr'){
              //   routesList.splice(indexA, 1);
              // } 
              if (!res.data.is_show_app_good) {
                itemA.children = itemA.children1;
                itemA.children.forEach((itemB, index) => {
                  if (
                    !res.data.is_show_course &&
                    itemB.index == "/courseManage"
                  ) {
                    // console.log("index---", index);
                    itemA.children = itemA.children.filter(
                      (itemB) => itemB.index != "/courseManage"
                    );
                  }
 


                  if (!res.data.is_show_vip && itemB.index == "/memberManage") {
                    // console.log("index---", index);
                    itemA.children = itemA.children.filter(
                      (itemB) => itemB.index != "/memberManage"
                    );
                  }
                  if (
                    !res.data.is_show_package &&
                    itemB.index == "/setMealList"
                  ) {
                    // console.log("index---", index, itemA.children);
                    itemA.children = itemA.children.filter(
                      (itemB) => itemB.index != "/setMealList"
                    );
                  }
                });
              } else {
                itemA.children = itemA.children2;
                itemA.children.forEach((itemB, index) => {
                  itemB.children.forEach((itemC) => {
                    if (
                      !res.data.is_show_course &&
                      itemC.index == "/courseManage"
                    ) {
                      // console.log("index---", index);
                      itemB.children = itemB.children.filter(
                        (itemC) => itemC.index != "/courseManage"
                      );
                    }
                    if (
                      !res.data.is_show_vip &&
                      itemC.index == "/memberManage"
                    ) {
                      // console.log("index---", index);
                      itemB.children = itemB.children.filter(
                        (itemC) => itemC.index != "/memberManage"
                      );
                    }
                    if (
                      !res.data.is_show_package &&
                      itemC.index == "/setMealList"
                    ) {
                      // console.log("index---", index, itemA.children);
                      itemB.children = itemB.children.filter(
                        (itemC) => itemC.index != "/setMealList"
                      );
                    }
                  });
                });
              }
            }
 
            if (
              itemA.index == "/recruitList" &&
              res.data.is_show_marketing != 1
            ) {
              routesList.splice(indexA, 1);
            }

            if (
              itemA.index == "/callPhoneManager" &&
              res.data.is_show_big_data != 1
            ) {
              routesList.splice(indexA, 1);
            }

            // if(this.role=='nstitutionalteacher' || this.role=='salespersonr' || this.role=='outboundcall'){
            //   if(itemA.index == "/home"){
            //     routesList.splice(indexA, 1);
            //   }  
            // }
            // if(this.role=='nstitutionalteacher'&&itemA.index == "/financialManage"){ 
            //     routesList.splice(indexA, 1); 
            // } 
            if (
              itemA.index == "/senioriupUserList" &&
              res.data.show_student_archive != 1
            ) {
              routesList.splice(indexA, 1);
            }

            if(itemA.index == "/studentDetails"){ 
              routesList.splice(indexA, 1); 
            }  
          });
          routesList.forEach((itemA, indexA) => {
            if (itemA.children && itemA.children.length == 0) {
              routesList.splice(indexA, 1);
            } else {
              // console.log("itemA---", itemA);
              // if (this.role != "admin" && itemA.index == "/callPhoneManager") {
              //   itemA.children.forEach((itemB, indexB) => {
              //     // console.log("itemB", itemB);
              //     if (itemB.index == "/taskList") {
              //       itemA.children.splice(indexB, 1);
              //     }
              //   });
              // }

              // if (
              //   this.role != "admin" &&
              //   this.role != "generaladministrato" &&
              //   itemA.index == "/extendManage"
              // ) {
              //   // console.log("extendManage---", itemA.children);
              //   itemA.children.forEach((itemB, indexB) => {
              //     if (
              //       itemB.index == "/tobSettlement" ||
              //       itemB.index == "/extendTeachManage" ||
              //       itemB.index == "/tobExperienceCard"
              //     ) {
              //       itemA.children.splice(indexB, 1);
              //     }
              //   });
              //   itemA.children.forEach((itemB, indexB) => {
              //     if (itemB.index == "/institutionalIncomeDetail") {
              //       itemA.children.splice(indexB, 1);
              //     }
              //   });
              // }
              // if (itemA.index == "/accountManage"&&itemA.children.length > 0) {
              //   itemA.children.forEach((itemB, indexB) => {
              //     console.log("itemB---", itemB, !res.data.is_study_card, this.role );
              //     if (!res.data.is_study_card || this.role== 'nstitutionalteacher' || this.role== 'salespersonr') {
              //       // console.log("itemB---", itemB);
              //       if (itemB.index == "/cardManage") {
              //         itemA.children.splice(indexB, 1);
              //       }
              //     }
              //   });  
              // }
              // console.log("itemA---", itemA, this.role);

            } 
          });
          // routesList.forEach((item) => {
          //   if(this.role=='nstitutionalteacher'||this.role=='salespersonr'){  
          //     item.children.forEach((itemB, indexB) => {
          //       if (itemB.index == "/cardExportLog") {
          //         item.children.splice(indexB, 1);
          //       }
          //     });  
          //   }
          // }) 
          routesList.forEach((item) => { 
            if(item.children && item.children.length > 0){
              item.children.forEach((itemB, indexB) => {
                if (itemB.index == "/helpManualInfo") {
                  item.children.splice(indexB, 1);
                }
              });
 
              if(item.children && item.children.length > 0){
                item.children.forEach((itemB, indexB) => {
                  if (itemB.index == "/helpManualList") {
                    item.children.splice(indexB, 1);
                  }
                });  
              }
 
              if(item.children && item.children.length > 0){
                item.children.forEach((itemB, indexB) => { 
                  if (itemB.index == "/customOrderList" && this.is_show_custom_order != 1) { 
                    item.children.splice(indexB, 1);
                  }
                });  
              } 
              if(item.children2 && item.children2.length > 0){
                item.children2.forEach((itemB, indexB) => {
                  if(itemB.children && itemB.children.length > 0){ 
                    itemB.children.forEach((itemC, indexC) => { 
                      if (itemC.index == "/customOrderList" && this.is_show_custom_order != 1) { 
                        itemB.children.splice(indexC, 1);
                      }
                    }) 
                  }
                });  
              } 

              
  
            }
 
          })
          localStorage.setItem("is_show_course", res.data.is_show_course);
          localStorage.setItem("is_show_vip", res.data.is_show_vip);
          localStorage.setItem("is_show_package", res.data.is_show_package);
          localStorage.setItem("is_show_marketing", res.data.is_show_marketing);
          localStorage.setItem("is_show_big_data", res.data.is_show_big_data); 
          localStorage.setItem("show_student_archive", res.data.show_student_archive); 

          routesList.forEach((item) => {
            if (item.index == "/home") {
              item.pic_a1 = require("../../assets/new/submenu_a1_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a1_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a1_3.png");
            }
            if (item.index == "/institutionsOption") {
              item.pic_a1 = require("../../assets/new/submenu_a9_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a9_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a9_3.png");
            }
            if (item.index == "/employeesManage") {
              item.pic_a1 = require("../../assets/new/submenu_a8_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a8_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a8_3.png");
            }
            if (item.index == "/financialManage") {
              item.pic_a1 = require("../../assets/new/submenu_a7_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a7_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a7_3.png");
            }
            if (item.index == "/accountManage") {
              item.pic_a1 = require("../../assets/new/submenu_a2_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a2_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a2_3.png");
            }
            if (item.index == "/goodsManage") {
              item.pic_a1 = require("../../assets/new/submenu_a3_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a3_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a3_3.png");
            }
            if (item.index == "/extendManage") {
              item.pic_a1 = require("../../assets/new/submenu_a4_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a4_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a4_3.png");
            }
            if (item.index == "/callPhoneManager") {
              item.pic_a1 = require("../../assets/new/submenu_a5_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a5_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a5_3.png");
            }
            if (item.index == "/orderManage") {
              item.pic_a1 = require("../../assets/new/submenu_a6_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a6_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a6_3.png");
            }
            if (item.index == "/helpCenter") {
              item.pic_a1 = require("../../assets/new/submenu_a1_1.png");
              item.pic_a2 = require("../../assets/new/submenu_a1_2.png");
              item.pic_a3 = require("../../assets/new/submenu_a1_3.png");
            }
          });

          this.routesList = routesList;  

          // this.activePath = ''
          // if(this.routesList[0].children && this.routesList[0].children.length > 0){
          //   this.activePath = this.routesList[0].children[0].index   
          //   this.$store.state.openTab = [
          //     {
          //       route: this.routesList[0].children[0].index ,
          //       name: this.routesList[0].children[0].name,
          //     }
          //   ];
          // } else {
          //   this.activePath = this.routesList[0].index 
          //   this.$store.state.openTab = [
          //     {
          //       route: this.routesList[0].index ,
          //       name: this.routesList[0].name,
          //     }
          //   ];
          // } 
          // this.getActivePath() 
          console.log("aaa", this.activePath, this.routesList[0].index, this.$store.state.openTab);

 
          const oldPath = this.$route.path
          const allIncludes = []
          this.routesList.forEach((itemA) => {
            allIncludes.push(itemA.index)
            if(itemA.children && itemA.children.length > 0){
              itemA.children.forEach((itemB) => {
                allIncludes.push(itemB.index)
              })
            }
          })

          console.log("ASDASD", oldPath, allIncludes.includes(oldPath)); 
          // if(!allIncludes.includes(oldPath) && oldPath != '/helpManualList' && oldPath != '/helpManualInfo'){ 
          //   this.$router.push(this.activePath);
          // } else 
          if(oldPath == '/helpManualList'){
            this.activePath = '/helpManualList'
            this.$store.state.openTab = [
              {
                route: '/helpManualList' ,
                name: '操作手册',
              }
            ];
          } else if(oldPath == '/helpManualInfo'){
            this.activePath = '/helpManualInfo'
            this.$store.state.openTab = [
              {
                route: '/helpManualInfo' ,
                name: '帮助手册-详情',
              }
            ];
          } else {
            this.activePath = oldPath

            this.routesList.forEach(itemA => {
              if(itemA.index == oldPath){
                this.$store.state.openTab = [
                  {
                    route: oldPath,
                    name: itemA.name,
                  }
                ];
              }
              if(itemA.children && itemA.children.length > 0){
                itemA.children.forEach(itemB => {
                  if(itemB.index == oldPath){
                    this.$store.state.openTab = [
                      {
                        route: oldPath,
                        name: itemB.name,
                      }
                    ];
                  }
                })
              }
            })

            // this.$store.state.openTab = [
            //   {
            //     route: oldPath ,
            //     name: '帮助手册-详情',
            //   }
            // ];
          }   
  
          this.$forceUpdate()
        }
      });
    },
    // shrinkClick() {
    //   this.isCollapse = !this.isCollapse;
    //   if (this.isCollapse) {
    //     document.getElementsByClassName("el-aside").style.width = "64px";
    //   }
    // },

    handleOpen(key, keyPath) {
      console.log('handleOpen', key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    routeSkip(item) {
      this.$router.push({ path: item.route });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  box-sizing: border-box;
  overflow-x: hidden;
  // overflow-y: scroll;
  // scrollbar-width: none;
  // -ms-overflow-style: none;

  .logoBox {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: center;
    .logoImg {
      width: 36px;
      height: 36px;
    }
    .title {
      display: flex;
      color: #ffffff;
      font-size: 17px;
      font-weight: bold;
    }
  }

  .el-menu-item:hover {
    .picA1 {
      display: none !important;
    }
    .picA2 {
      display: inline-block !important;
    }
    .picA3 {
      display: none !important;
    }
  }

  .noChild {
    .el-menu-item {
      background: #282637 !important;
    }
    .is-active {
      // background: #7861ff !important;
      // color: #fff !important;
      color: #7861ff !important;
      .picA1 {
        display: none !important;
      }
      .picA2 {
        display: inline-block !important;
      }
      .picA3 {
        display: none !important;
      }
    }
    .is-active:hover {
      // background: #7861ff !important;
      // color: #fff !important;
      color: #7861ff !important;
      background: #181626 !important;

      .picA1 {
        display: none !important;
      }
      .picA2 {
        display: inline-block !important;
      }
      .picA3 {
        display: none !important;
      }
    }
  }

  .el-menu-item:hover {
    // background: #7861ff !important;
    // color: #fff !important;
    color: #7861ff !important;
    background: #181626 !important;
  }
  .is-active {
    background: #7861ff !important;
    color: #fff !important;
  }

  .is-active:hover {
    background: #7861ff !important;
    color: #fff !important;
  }
}
/deep/ .el-menu-item {
  width: 200px;
  i {
    vertical-align: -1px;
  }
}
/deep/ .el-submenu.is-active {
  .el-submenu__title {
    color: #7861ff !important;

    .picA1 {
      display: none !important;
    }
    .picA2 {
      display: inline-block !important;
    }
    .picA3 {
      display: none !important;
    }
  }
}
/deep/ .el-submenu__title {
  width: 200px;
  background-color: #282637 !important;

  .picA1 {
    display: inline-block !important;
    margin-right: 3px;
  }
  .picA2 {
    display: none !important;
    margin-right: 3px;
  }
  .picA3 {
    display: none !important;
    margin-right: 3px;
  }
}
/deep/ .el-submenu__title:hover {
  color: #7861ff !important;
  .picA1 {
    display: none !important;
  }
  .picA2 {
    display: inline-block !important;
  }
  .picA3 {
    display: none !important;
  }
}

.shrink {
  color: #909399;
}
/deep/ .el-menu {
  border-right: none !important;
  // background-color: #181626 !important;
}

/deep/.el-menu-item {
  .picA1 {
    display: inline-block !important;
    margin-right: 3px;
  }
  .picA2 {
    display: none !important;
    margin-right: 3px;
  }
  .picA3 {
    display: none !important;
    margin-right: 3px;
  }
}
.el-menu--collapse .haveChild {
  .el-submenu:hover {
    background-color: red !important;
    position: relative;
  }
  .el-submenu::after {
    content: "";
    display: none;
    position: absolute;
    right: 0;
    top: 25px;
    z-index: 111;
    border: 5px solid #282637;
    border-right-color: #fff;
  }
}
.el-menu--collapse .haveChild:hover {
  .el-submenu::after {
    display: block;
  }
}
</style>
